<title>Autoverkoop Partner - Verificatie code</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        @if (hasClickedDecline) {
          <ngb-alert type="warning">Deze aanvraag is reeds geaccepteerd. Afwijzen van het
          bod is niet meer mogelijk. </ngb-alert>
        }

        <h1 class="font-weight-light">Controle</h1>

        @if (codeSend == false) {
          <div>
            <p class="lead">
              Om zeker te weten dat jij het bent verzenden we een code naar je mobiele telefoonnummer.
            </p>
            <button (click)="sendCode()" type="button" class="btn btn-primary">Vraag code aan</button>
          </div>
        }

        @if (codeSend == true) {
          <div>
            @if (codeResponse && codeResponse.error == false) {
              <div class="alert alert-success" role="alert">
                Er is een code verstuurd naar: {{codeResponse.data}}
              </div>
            }
            @if (newCodeSend) {
              <div class="alert alert-warning" role="alert">
                Er is een nieuwe code verstuurd.
              </div>
            }
            @if (codeResponse && codeResponse.error == true) {
              <div class="alert alert-danger" role="alert">
                Er is een fout opgetreden bij het verzenden van de code. Neem contact op met onze <a
              href="https://autoverkooppartner.nl/klantenservice/">klantenservice</a> om verder te gaan.
            </div>
          }
          @if (codeResponse && codeResponse.error == false) {
            <div>
              <p class="lead">
                Voer de ontvangen code in om verder te gaan.
              </p>
              @if (codeIncorrect) {
                <div class="alert alert-warning" role="alert">
                  De ingevoerde code is onjuist.
                </div>
              }
              <form [formGroup]="verificationForm">
                <div class="row">
                  <div class="form-group col-md-4">
                    <input formControlName="code" (keyup.enter)="checkCode()" type="text"
                      class="form-control" placeholder="Code">
                  </div>
                </div>
              </form>
              <div class="row">
                <div class="form-group col">
                  <a (click)="sendNewCode()">Nieuwe code versturen</a>
                </div>
              </div>
              <button [disabled]="verificationForm.invalid" (click)="checkCode()" type="button"
              class="btn btn-primary">Controleer</button>
            </div>
          }
        </div>
      }
      <div style="height: 700px"></div>
    </div>
  </div>
</div>